// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'more-alt';

export const Component = () => (
  <path d='M6.353 11.575c.383.383.575.862.575 1.39 0 .526-.191 1.005-.575 1.388a1.919 1.919 0 0 1-1.389.575 1.917 1.917 0 0 1-1.389-.575A1.919 1.919 0 0 1 3 12.964c0-.527.191-1.005.575-1.389A1.919 1.919 0 0 1 4.965 11c.526 0 1.005.191 1.388.575Zm7.375 0c.383.383.575.862.575 1.39 0 .526-.191 1.005-.575 1.388a1.919 1.919 0 0 1-1.389.575 1.917 1.917 0 0 1-1.389-.575 1.919 1.919 0 0 1-.575-1.389c0-.527.191-1.005.575-1.389A1.919 1.919 0 0 1 12.34 11c.526 0 1.005.191 1.388.575Zm7.376 0c.383.383.575.862.575 1.39 0 .526-.191 1.005-.575 1.388a1.919 1.919 0 0 1-1.39.575 1.917 1.917 0 0 1-1.388-.575 1.919 1.919 0 0 1-.575-1.389c0-.527.191-1.005.575-1.389A1.919 1.919 0 0 1 19.715 11c.527 0 1.005.191 1.389.575Z' />
);

export const viewBox = '0 0 25 25';
